import i18n from "i18next";

export function formatNumber(number) {
  if (number !== null && number !== undefined) {
    return new Intl.NumberFormat(i18n.language).format(number);
  }

  return number;
}
